module.exports = __webpack_public_path__ + "img/8-990x742.a1b6dc60.jpg";